var map = {
	"./en.json": [
		80517,
		517
	],
	"./es.json": [
		77966,
		7966
	],
	"./fr.json": [
		60934,
		934
	],
	"./pt.json": [
		86186,
		6186
	],
	"./ru.json": [
		89327,
		9327
	],
	"./zh.json": [
		66160,
		6160
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 15543;
module.exports = webpackAsyncContext;